'use client'
import { FC, ReactNode, ButtonHTMLAttributes } from 'react'
import cn from 'classnames'

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
}

export const ActionButton: FC<ActionButtonProps> = ({ children, className, ...props }) => {
  return (
    <button
      className={cn(
        'bg-base-medium-light flex size-12 items-center justify-center rounded-full',
        'hover:bg-primary-base text-white transition-colors',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
